import { CopyToClipboard } from '../copy-to-clipboard';

import { ShareInviteUrlModal } from '@/state/modals';

export const Config = {
  title: 'Inviter un collègue à rejoindre la plateforme',
};

export function Component({ url }: ShareInviteUrlModal) {
  return (
    <div className="flex flex-col gap-8">
      <p className="text-sm text-muted-foreground">
        Invitez vos collègues en partageant ce lien. Ils pourront s'inscrire et seront automatiquement ajoutés à votre
        équipe.
      </p>
      <CopyToClipboard value={url} />
    </div>
  );
}
